export const colors = [
  { color: "bg-white" },
  { color: "bg-black" },
  { color: "bg-rose-300" },
  { color: "bg-red-300" },
  { color: "bg-amber-300" },
  { color: "bg-yellow-300" },
  { color: "bg-orange-300" },
  { color: "bg-lime-300" },
  { color: "bg-green-300" },
  { color: "bg-emerald-300" },
  { color: "bg-teal-300" },
  { color: "bg-cyan-300" },
  { color: "bg-sky-300" },
  { color: "bg-blue-300" },
  { color: "bg-indigo-300" },
  { color: "bg-violet-300" },
  { color: "bg-fuchsia-300" },
  { color: "bg-pink-300" },
  { color: "bg-rose-600" },
  { color: "bg-red-600" },
  { color: "bg-amber-600" },
  { color: "bg-yellow-600" },
  { color: "bg-orange-600" },
  { color: "bg-lime-600" },
  { color: "bg-green-600" },
  { color: "bg-emerald-600" },
  { color: "bg-teal-600" },
  { color: "bg-cyan-600" },
  { color: "bg-sky-600" },
  { color: "bg-blue-600" },
  { color: "bg-indigo-600" },
  { color: "bg-violet-600" },
  { color: "bg-fuchsia-600" },
  { color: "bg-pink-600" },
  { color: "bg-slate-300" },
  { color: "bg-zinc-300" },
  { color: "bg-stone-300" },
  { color: "bg-slate-600" },
  { color: "bg-zinc-600" },
  { color: "bg-stone-600" },
];
